import { TableColumnsType } from "antd";
import React from "react";
import ReusableTable from "../../../../../../global components/Table/Table";
import NoData from "../../../../../../global components/Table/NoData/NoData";
import { PieChart } from "../../../../../../global components/Icons/PieChart";
import { PaginatedVoiceReportType } from "../../../../../../libs/Utils/Types/Reports";
import dayjs from "dayjs";
import Unauthorised from "../../../../../../global components/Unauthorised";
type ColumnsType = {
  serialNumber: number;
  key: number;
  date: string;
  totalRecipients: number;
  avgDuration: string;
};
type PropType = {
  isLoading: boolean;
  dataSource: PaginatedVoiceReportType["data"];
  unauthorized: boolean | { title: string; message: string };
};
function VoiceReportTable({ dataSource, isLoading, unauthorized }: PropType) {
  const columns: TableColumnsType<ColumnsType> = [
    {
      title: "S/N",
      dataIndex: "serialNumber",
      key: "serialNumber",
      render: (serialNumber: number) => <span>{serialNumber}</span>,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date: string) => <span>{date}</span>,
    },

    {
      title: "Total Recipients",
      dataIndex: "totalRecipients",
      key: "totalRecipients",
    },
    {
      title: "Avg. Duration",
      dataIndex: "avgDuration",
      key: "avgDuration",
      render: (voiceFailed: string) => <span>{voiceFailed}</span>,
    },
  ];
  const data: ColumnsType[] =
    dataSource.map((item, index) => ({
      date: dayjs.utc(item.date).local().format("MMM DD, YYYY"),
      key: index + 1,
      serialNumber: index + 1,

      avgDuration: item.avgDuration,
      totalRecipients: item.totalRecipients,
    })) ?? [];
  return (
    <ReusableTable
      columns={columns}
      dataSource={data}
      loading={isLoading}
      noDataComponent={
        unauthorized ? (
          typeof unauthorized === "boolean" ? (
            <Unauthorised />
          ) : (
            <Unauthorised error={unauthorized} />
          )
        ) : (
          <NoData
            Message="No voice report found"
            subMessage=""
            icon={<PieChart height={32} width={32} />}
          />
        )
      }
    />
  );
}

export default VoiceReportTable;
